import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IShopShippingOption } from '../../../models/shop/shopshippingoption';
import { formatCurrency } from 'helpers/common';
import * as moment from 'moment';

require('./style.css');

export interface IProps {
	input?: any;
	meta: { touched; error; warning };
	shippingOptions?: IShopShippingOption[];
	currencyKey?: number;
	shopGroupTotal?: number;
	onChangeAction?: (ev: any) => void;
	selectedShippingOptionId?: string;
	change: (field: string, value: any) => void;
	t?: (key: string, props?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CartShippingOptionsRadioGroup extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		const { selectedShippingOptionId, change, input } = this.props;
		if (selectedShippingOptionId) {
			change(input.name, selectedShippingOptionId);
		}
	}

	public render() {
		const { t, shippingOptions, input, onChangeAction, currencyKey, selectedShippingOptionId, shopGroupTotal } =
			this.props;
		const { error, touched, warning } = this.props.meta;

		if (!shippingOptions) {
			return null;
		}

		return (
			<div className="cartShippingOptionsRadioGroup">
				<div className="titleDelivery">{t('Cart_CheckoutShippingOptions_ChooseDeliveryOption')}</div>
				<div>
					{shippingOptions.map((shippingOption: IShopShippingOption) => {
						let price = formatCurrency(currencyKey, shippingOption.price);
						if (
							shippingOption.freeShipping &&
							(!shippingOption.freeShippingMinAmount || shopGroupTotal >= shippingOption.freeShippingMinAmount)
						) {
							price = t('Cart_CheckoutShippingOptions_Free');
						}
						const expectedDeliveryDate = new Date();
						expectedDeliveryDate.setDate(expectedDeliveryDate.getDate() + shippingOption.daysMax);
						return (
							<div key={shippingOption.id} className="wrapperDeliveryCard">
								<div className="leftSideCheckbutton">
									<input
										type="radio"
										{...input}
										value={shippingOption.id}
										checked={shippingOption.id === selectedShippingOptionId}
										onChange={(e) => {
											if (onChangeAction) {
												onChangeAction(e);
											}
											input.onChange(e);
										}}
									/>
									<span className="name"> {shippingOption.name}</span>
								</div>
								<div className="middleExpectedDelivery">
									{t('Cart_CheckoutShippingOptions_ExpectedDelivery', {
										date: moment(expectedDeliveryDate).format('LL'),
									})}
								</div>
								<div className="price">{price}</div>
							</div>
						);
					})}
				</div>
				{touched && ((error && <span className="requiredfield">{error}</span>) || (warning && <span>{warning}</span>))}
			</div>
		);
	}
}

export { CartShippingOptionsRadioGroup };
